import React, { ComponentProps, ComponentType } from 'react';
import { Route } from 'react-router-dom';
import { PublicOrBusinessLayout } from 'parent-portal/navigation';

type PublicOrBusinessLayoutOptions = Omit<ComponentProps<typeof PublicOrBusinessLayout>, 'children'>;

type PublicOrBusinessProps = Omit<ComponentProps<typeof Route>, 'component' | 'render' | 'children'> & {
    component: ComponentType<Record<string, unknown>>;
    layoutProps?: PublicOrBusinessLayoutOptions;
};

export function PublicOrBusiness({ component: Component, layoutProps, ...rest }: PublicOrBusinessProps) {
    return (
        <Route
            {...rest}
            render={(props) => (
                <PublicOrBusinessLayout {...layoutProps}>
                    <Component {...props} />
                </PublicOrBusinessLayout>
            )}
        />
    );
}
